<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardHeader class="bg-primary text-white d-flex align-items-center font-weight-bold">
      {{ this.$string.sidebar.menu_6.sub_menu.menu_3 }}
      <CButton
        color="success"
        class="btn-md ml-auto"
        @click="createData"
      >Tambah</CButton>
    </CCardHeader>
    <!-- Data Sales Order -->
    <CCardBody>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable 
              style="widht:100% !important" 
              :items="items" 
              :fields="fields"
              :tableFilter='{ label:"Pencarian", placeholder:"Cari Data .." }'
              :items-per-page="10"              
              :items-per-page-select='{ label : "Data Per Halaman"}' hover sorter>
            <template #no="{index}">
              <td class="py-2">{{ index+1 }}</td>
            </template>
            <template #file="{item}">
              <td class="py-2">
                <button @click="lihatFile(item.file)" class="btn btn-success p-0 px-3 shadow mx-auto" type="button" :disabled="item.file == ''">
                    {{ item.file == null || item.file == "null" ? '-' : 'Lihat File' }}
                </button>
              </td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-center">
                <font-awesome-icon icon="check" class="text-success" v-if="item.status == 1" />
                <font-awesome-icon icon="times" class="text-danger" v-else />
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center">
                <CButton color="info" class="btn-sm text-white" square @click="updateData(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" class="btn-sm" square @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCol>
      </CRow>
      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
       >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <CCol sm="12">
              <CInput class="font-weight-bold" label="Nama" placeholder="Masukkan nama e-kwitansi" v-model="formData.nama"/>
            </CCol>

            <CCol sm="12 mb-3">
              <label for="uid-zwqayuopq3" class="font-weight-bold">
                Unggah File
                <small v-if="actionPost == 'update'">
                  <span @click="lihatFile">(Lihat File)</span>
                </small>
              </label>
              <br />
              <div class="custom-file text-truncate">
                <input 
                  type="file"
                  class="custom-file-input"
                  id="customFileLangHTML"
                  ref="uploadFileKwitansi"
                  :required="actionPost == 'update'"
                  @change="fileUpload"
                />
                <label
                  class="custom-file-label"
                  for="customFileLangHTML"
                  data-browse="Unggah"
                >{{ typeof formData.file === "string" ? formData.file : fileName }}</label>
              </div>
              <small class="text-danger">(*File harus bertipe PDF max. 10MB)</small>              
            </CCol>

            <CCol sm="12 mb-4">
              <label for class="font-weight-bold">Status</label>
              <br />
              <div class="d-flex align-items-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="aktif"
                    checked
                    value="1"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="aktif">Aktif</label>
                </div>
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    type="radio"
                    class="custom-control-input"
                    name="customRadio"
                    id="tidak_aktif"
                    value="0"
                    v-model="formData.status"
                  />
                  <label class="custom-control-label" for="tidak_aktif">Tidak Aktif</label>
                </div>
              </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{title}}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
    <!-- End Data Sales Order -->
</CCard>
</template>
<script>
import KwitansiServices from "../../../services/finance/e-kwitansi.service"
import {AlertUtils} from '../../../mixins/AlertUtils'
import BaseUrl from "../../../services/base-url";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: false
  },
  {
    key: "nama",
    label: "Nama",
    sorter: true,
    filter: false
  },
  {
    key: "file",
    label: "File",
    sorter: true,
    filter: false
  },  
  {
    key: "status",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  },
  {
    key: "aksi",
    _style: "width: 12%; text-align: center",
    sorter: false,
    filter: false
  }
];

export default {
  mixins: [AlertUtils],
  data() {
    return {
      items: [],
      formData: {
        nama: "",
        file: "",
        status: "",
        statusUpdateFile: "",
        idKwitansi: ""
      },
      fileName: "Pilih FIle ...",
      fields,
      actionPost: "",
      title: "",
      status: false,
      myModal: false,
      content: []
    };
  },

  mounted() {
    this.getData()
    this.baseUrl = BaseUrl();
    $(document).on("click", ".browse", function() {
      var file = $(this)
        .parent()
        .parent()
        .parent()
        .find(".file");
      file.trigger("click");
    });
    $(document).on("change", ".file", function() {
      $(this)
        .parent()
        .find(".form-control")
        .val(
          $(this)
            .val()
            .replace(/C:\\fakepath\\/i, "")
        );
    });
  },

  methods: {
    getData() {
      KwitansiServices.getKwitansi() 
      .then(response => {
        this.items = response.data.data;
      })
    },
    
    createData() {
      this.myModal = true;
      this.formData = {};
      this.formData.file = null;
      /**
       * #HANDLING#
       * 
       * Handling Upload File Jika File Yang Di Upload Sama
       */
      this.$refs.uploadFileKwitansi.value = null;
      this.fileName = "";
      this.actionPost = "insert";
      this.title = "Tambah";
    },

     postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      var vm = this;
      if (typeof formData.file === "string") {
        delete formData.file
      }
      if (formData.file === null) {
        delete formData.file
      }
      KwitansiServices.postKwitansi(formData).then(
        () => {
          vm.myModal = false;
          vm.alertSuccess()      
          vm.getData();
        },
        error => {
          vm.alertError();
        }
      );
    },

    putData() {
      // comment console console.log("put");
      // comment console console.log(this.formData);
      if (typeof this.formData.file === "string") {
        delete this.formData.file;
      }

      if (this.formData.file === null) {
        delete this.formData.file;
      }
      var vm = this;
      KwitansiServices.putKwitansi(this.formData)
        .then(response => {
          vm.myModal = false;

          vm.alertEditSuccess();

          vm.getData();
        })
        .catch(error => {
          // comment console console.log(error);

          this.alertError();
        });
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.actionPost = "update";
      this.title = "Edit";
    },

    lihatFile(file) {
      if (file != "" && file != null) {
        let routeData =
          this.baseUrl +
          "/files?filename=" +
          file +
          "&path=finance@ekwitansi";
        let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=0,height=0,left=-1000,top=-1000`;
        window.open(
         routeData,
          file,
          params
        );
        return false;
      } else {
        this.$swal.fire({
          title: "Informasi",
          text: "File Tidak Ditemukan.",
          icon: "info",
          confirmButtonText: "Tutup",
          showConfirmButton: true
        });
      }
    },

    deleteData(item, index) {
      this.formData = item;
      var vm = this;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            KwitansiServices.deleteKwitansi(this.formData)
              .then(response => {
                // comment console console.log(response);
                vm.alertDeleteSuccess();
                vm.getData();
              })
              .catch(error => {
                vm.alertErrorMessage(error.response.data.message);
                // comment console console.log(error);
              });
            Toast.fire({
              icon: "cancel",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    fileUpload(e) {      
      this.formData.file = e.target.files[0];
      this.fileName = e.target.files[0].name;
      // comment console console.log(e.target.files);
    },
  }
  }
</script>